module.exports = __webpack_public_path__ + "img/Logo_FondoNegro_LetrasBlancas.591626ff.svg";